import React, { useState, Fragment} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.js";
import { Row, Col, FormGroup, Container, Input, UncontrolledButtonDropdown, DropdownItem, Button, DropdownMenu  } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { CustomText, Estado } from  '../../Utility/CustomList/index'
import * as Icon from 'react-feather'




const List = ({allData, Actions, One}) => {
  const [searchValue, setSearchValue] = useState(''),
        [filteredData, setFilteredData] = useState([]),
      handleFilter = e => {
      const value = e.target.value
      let updatedData = []
      setSearchValue(value)

      if (value.length) {
        updatedData = allData.filter(item => {
          const startsWith =
            item.nombres.toLowerCase().startsWith(value.toLowerCase()) ||
            item.apellidos.toLowerCase().startsWith(value.toLowerCase())
          const includes =
            item.nombres.toLowerCase().startsWith(value.toLowerCase()) ||
            item.apellidos.toLowerCase().startsWith(value.toLowerCase())

          if (startsWith) {
            return startsWith
          } else if (!startsWith && includes) {
            return includes
          } else return null
        })
        setFilteredData(updatedData)
        setSearchValue(value)
      }
      }
  const  Columns = [
        {
          name: 'Nombres',
          column: 'nombres',
          center: true,
          cell: row => CustomText(row['nombres'])
        },
        {
          name: 'Apellidos',
          column: 'apellidos',
          center: true,
          cell: row => CustomText(row['apellidos'])
        },
        {
            name: 'Telefono',
            column: 'telefono',
            center: true,
            cell: row => CustomText(row['telefono'])
        },
        {
            name: 'Direccion',
            column: 'direccion',
            center: true,
            cell: row => CustomText(row['direccion'])
        },
        {
          name: "Estado",
          column: "estado",
          center: true,
          width: "200px",
          cell: (row) => <Estado row={row} />,
        },
        {
          name: 'Acciones',
          column: 'id',
          center: true,
          cell: row => (
            <UncontrolledButtonDropdown>
              
              <DropdownItem onClick={() => One(row, 3)}>
                <Icon.Edit className="mr-2" size={15} />
              </DropdownItem>
              <DropdownItem onClick={() => Actions(row) }>
              <Icon.Check className="mr-2" size={15} />  
               
              </DropdownItem>
           
          </UncontrolledButtonDropdown>
          )
        }
    ]

    return(
        <div className="list">
            <Row>
             <Col>
           

                   <Button> Export excel </Button>

              
             </Col>
            <Col className='justify-content-end mt-1' md='4' sm='12'>
                    <FormGroup>
                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='md'
                            placeholder={`Buscar`}
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
            <Container>
            <DataTable
                // dense
                noHeader
                highlightOnHover
                pagination
                defaultSortFieldID={1}
                data={searchValue.length ? filteredData : allData }          
                columns={Columns}
                className='table-responsive'
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                paginationComponentOptions={
                    {
                    rowsPerPageText: '',
                    rangeSeparatorText:''
                    }
                }
                noDataComponent='Sin Registros'
            />
        </Container>
        </Row> 
        </div>
       
        
        
        
    )
}

export default List